import React, { useEffect } from "react";
import useOTT from "@shared/hooks/user/useOTT";
import MedenticAuthEntryPage from "@shared/ui/MedenticAuthEntryPage";
import { Box, InlineStack, Spinner, Text } from "@medentic/polaris-react";
import { ROUTES } from "@app/config/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OttExchange: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleOTT, setReloadOnOttExchange } = useOTT();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const ott = queryParams.get("ott");
    queryParams.delete("ott");
    if (ott) {
      setReloadOnOttExchange(true);
      handleOTT(ott);
    } else {
      navigate(ROUTES.LOGIN);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setReloadOnOttExchange, handleOTT]);

  return (
    <MedenticAuthEntryPage width="sm" enableAuthRouteRedirect>
      <InlineStack align="start">
        <Text as="h1" fontWeight="bold" variant="headingLg">
          {t("auth.login.LoggingYouIn")}
        </Text>
      </InlineStack>
      <InlineStack align="center">
        <Box padding={"1600"}>
          <Spinner />
        </Box>
      </InlineStack>
    </MedenticAuthEntryPage>
  );
};

export default OttExchange;
